import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("yoyo_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("yoyo_cart", JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product, taille, quantite = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id && i.taille === taille);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantite: copy[idx].quantite + quantite };
        return copy;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          nom: product.nom,
          prix: product.prix,
          image: product.images && product.images[0],
          taille,
          quantite,
        },
      ];
    });
  }, []);

  const removeItem = useCallback((product_id, taille) =>
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.taille === taille))), []);

  const updateQty = useCallback((product_id, taille, quantite) =>
    setItems((prev) =>
      prev.map((i) =>
        i.product_id === product_id && i.taille === taille
          ? { ...i, quantite: Math.max(1, quantite) }
          : i
      )
    ), []);

  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.prix * i.quantite, 0);
    const count = items.reduce((s, i) => s + i.quantite, 0);
    return { items, addItem, removeItem, updateQty, clear, subtotal, count };
  }, [items, addItem, removeItem, updateQty, clear]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
